import type { CardClass } from "../data/types";
import { POOL_COLS, POOL_ROWS } from "../utils/sssLogic";

interface Props {
  name: string;
  cardClass: CardClass;
  variant: "in-window" | "in-selection" | "out";
  size?: "sm" | "md";
  spriteSrc: string;
  poolRow: number;
  poolCol: number;
}

const SIZE_CLASSES = {
  sm: "w-full sm:w-[72px] md:w-[90px]",
  md: "w-full sm:w-[100px] md:w-[120px]",
} as const;

const LABEL_SIZES = {
  sm: "text-[10px] sm:text-[10px]",
  md: "text-[11px] sm:text-[11px]",
} as const;

export function CardCell({
  name,
  cardClass: _cardClass,
  variant,
  size = "sm",
  spriteSrc,
  poolRow,
  poolCol,
}: Props) {
  const bgPosX = (poolCol / (POOL_COLS - 1)) * 100;
  const bgPosY = (poolRow / (POOL_ROWS - 1)) * 100;
  const bgSize = `${POOL_COLS * 100}% ${POOL_ROWS * 100}%`;

  const ringCls =
    variant === "in-window"
      ? "ring-1 ring-sky-400 border-sky-400"
      : variant === "in-selection"
        ? "border-slate-400 opacity-80"
        : "border-slate-300 opacity-25";

  const labelCls =
    variant === "in-window"
      ? "bg-sky-50 text-slate-800"
      : variant === "in-selection"
        ? "bg-slate-50 text-slate-700"
        : "bg-white text-slate-500";

  return (
    <div
      className={`flex flex-col overflow-hidden rounded border bg-slate-200 ${SIZE_CLASSES[size]} ${ringCls}`}
    >
      <div
        className="aspect-[4/3] w-full bg-no-repeat"
        style={{
          backgroundImage: `url(${spriteSrc})`,
          backgroundSize: bgSize,
          backgroundPosition: `${bgPosX}% ${bgPosY}%`,
          imageRendering: "pixelated",
        }}
        title={name}
      />
      <div
        className={`truncate px-0.5 py-0.5 text-center leading-tight ${LABEL_SIZES[size]} ${labelCls}`}
      >
        {name}
      </div>
    </div>
  );
}
